// @ts-nocheck
import React, { Component } from 'react';
import styles from '../css/VacantSubstitutionResult.module.css';

class VacantSubstitutionResult extends Component {
    render() {
        const { data, number, onEdit, onDelete } = this.props;
        const isOverride = data.IS_OVERRIDE === true || data.IS_OVERRIDE === 1;
        const odd = number % 2 !== 0;

        return (
            <div className={odd ? [styles.Row, styles.odd].join(' ') : styles.Row}>
                <div className={styles.colVacant}>
                    <div className={styles.terrId}>{data.VACANT_TERR_ID || '-'}</div>
                    <div className={styles.terrName}>{data.VACANT_TERR_NAME || '-'}</div>
                </div>
                <div className={styles.colSubRep}>
                    <div className={styles.repName}>{data.FIRST_NAME && data.LAST_NAME ? `${data.FIRST_NAME} ${data.LAST_NAME}` : '-'}</div>
                    <div className={styles.repEmail}>{data.SUB_EMAIL || '-'}</div>
                </div>
                <div className={styles.colSubTerr}>
                    <div className={styles.terrId}>{data.SUB_TERR_ID || '-'}</div>
                    <div className={styles.terrName}>{data.SUB_TERR_NAME || '-'}</div>
                </div>
                <div className={styles.colMgr}>
                    <div>{data.VACANT_DIST_MGR_NAME || '-'}</div>
                </div>
                <div className={styles.colStatus}>
                    {isOverride
                        ? <span className={styles.badgeOverride}>OVERRIDE</span>
                        : <span className={styles.badgeAuto}>AUTO</span>
                    }
                </div>
                <div className={styles.colActions}>
                    <div className={styles.link} onClick={onEdit}>Edit</div>
                    {isOverride && (
                        <div className={[styles.link, styles.clearLink].join(' ')} onClick={onDelete}>Clear</div>
                    )}
                </div>
            </div>
        );
    }
}

export default VacantSubstitutionResult;
